import { useUserInfo } from "../../../shared/hooks/use-user-info";

import { ProfileRow } from "./profile-row";

export const ProfileInfoSection = () => {
  const userInfo = useUserInfo();
  const fullName = userInfo?.fullName ?? "—";
  const email = userInfo?.email || "—";

  return (
    <div className="mt-6">
      <ProfileRow label="ФИО">{fullName}</ProfileRow>
      <ProfileRow label="e-mail">{email}</ProfileRow>
    </div>
  );
};
